export const coreRequirements = {
  frontend: '3.8.0.45',
  backend: '4.7.0.144',
  'bento-core': '1.0.0',
};

export const microServiceRequirements = {
  file: '2.0.0.35',
  auth: '2.0.0-18',
  user: '1.0.0.19',
};

export const dependencyRequirements = {
  node: '16.17.1',
  npm: '8.15.0',
};
